export default "__VITE_ASSET__D0TSmoP5__"